import $ from 'jquery'

const multiSubmitTimeout = 2000

export function initialise() {
  $('.multi-dropdown').each((i, elem) => {
    const $dropdown = $(elem)
    const $label = $dropdown.find('.multi-dropdown-label')
    const $labelText = $label.find('span')
    const $checkboxes = $dropdown.find('.multi-dropdown-option > .control > input')
    const $hiddenInput = $dropdown.find('input[type="hidden"]')
    const $submit = $dropdown.find('.multi-dropdown-submit')
    const $clear = $dropdown.find('.multi-dropdown-clear')
    const form = $hiddenInput.get(0).form

    let dropdownOpen = false
    let dropdownSubmitTimeout = null
    const originalLabelText = $labelText.html()
    const multiple = $dropdown.data('multidropdown-multiple')
    const autosubmit = $dropdown.data('multidropdown-autosubmit')
    const delimiter = $dropdown.attr('data-multidropdown-delimiter') || '-'

    // clear empty values before submit to tidy up url
    const formOnSubmit = () => {
      $(form)
        .serializeArray()
        .forEach(({ name, value }) => {
          if (!value) $(form).find(`:input[name="${name}"]`).attr('disabled', 'disabled')
        })
      return true
    }

    // used when manually triggering submit as this does not trigger onsubmit event
    const submitForm = () => formOnSubmit() && form.submit()

    // update selected count in label
    const updateLabelCount = () => {
      originalLabelText
      let totalChecked = 0
      $checkboxes.each((i, checkbox) => (totalChecked += $(checkbox).is(':checked') ? 1 : 0))
      if (totalChecked > 0) $labelText.html(originalLabelText + ' (' + totalChecked + ')')
      else $labelText.html(originalLabelText)
    }

    $(form).on('submit', formOnSubmit)

    if (multiple) {
      updateLabelCount()

      // prevent form from submitting twice
      $(form).on('submit', (e) => {
        if (dropdownSubmitTimeout) clearTimeout(dropdownSubmitTimeout)
      })
    }

    if (!$checkboxes.length) {
      $dropdown.css('opacity', 0.5)
    }

    // set up dropdown toggle event
    $label.on('click', (e) => {
      if (!$checkboxes.length) return
      if ($dropdown.hasClass('open')) {
        $dropdown.removeClass('open')
        dropdownOpen = false
      } else {
        $dropdown.addClass('open')
        if (dropdownOpen) $dropdown.removeClass('open')
        dropdownOpen = true
      }
    })

    // set up checkbox toggle events
    $checkboxes.each((i, checkbox) => {
      $(checkbox).on('change', (e) => {
        const select = e.target.value
        const checked = e.target.checked

        let currentValue = ($hiddenInput.val() || '').split(delimiter)
        if (multiple) {
          if (checked) currentValue = [...currentValue, select]
          else currentValue = currentValue.filter((val) => val != select)
          currentValue = currentValue.filter((_) => _)
          updateLabelCount()
        } else {
          currentValue = checked ? [select] : []
          $checkboxes.each((i, test) => test != checkbox && $(test).prop('checked', false))
        }
        $hiddenInput.val(currentValue.join(delimiter))

        if (autosubmit) {
          if (multiple) {
            if (dropdownSubmitTimeout) clearTimeout(dropdownSubmitTimeout)
            dropdownSubmitTimeout = setTimeout(submitForm, multiSubmitTimeout)
          } else {
            submitForm()
          }
        }
      })
    })

    // set up submit event
    $submit.on('click', (e) => {
      e.preventDefault()
      $dropdown.removeClass('open')
      dropdownOpen = false
      submitForm()
    })

    // set up clear event
    $clear.on('click', (e) => {
      e.preventDefault()
      $checkboxes.each((i, checkbox) => $(checkbox).prop('checked', false))
      $hiddenInput.val('')
      if (autosubmit) {
        if (dropdownSubmitTimeout) clearTimeout(dropdownSubmitTimeout)
        dropdownSubmitTimeout = setTimeout(submitForm, multiSubmitTimeout)
      }
    })

    // set up mouseup handler to close dropdown if click registers outside it
    $(document).on('mouseup', (e) => {
      if (dropdownOpen && !$dropdown.is(e.target) && $dropdown.has(e.target).length === 0) {
        $dropdown.removeClass('open')
        dropdownOpen = false
        if (dropdownSubmitTimeout) clearTimeout(dropdownSubmitTimeout)
      }
    })
  })
}
